import cloneDeep from 'lodash/cloneDeep'
import baseDefaults from '../Base/Base.defaults'

export default {
	...cloneDeep(baseDefaults), 
	useCookie: true,
	type: 'toDate',
	toDateDate: 'Tue Jun 08 2021 00:00:00 GMT+0200 (Central European Summer Time)',
	daysLabel: 'Days',
	hoursLabel: 'Hours',
	minutesLabel: 'Minutes',
	secondsLabel: 'Seconds',
	bgColor: 'var(--color-white)',
	borderColor: 'var(--color-primary)',
	dateColor: 'var(--color-primary)',
	labelColor: 'var(--color-primary)',
	expireAction: {},
	display: []
}
